import { starItems } from '@/mocks/gossip';
import SectionHeading from '@/pages/home/components/SectionHeading';

export default function StarSection() {
  return (
    <section id="stars" className="w-full bg-background-50 py-14 md:py-20">
      <div className="w-full px-4 md:px-8">
        <SectionHeading
          eyebrow="STARS · 明星黑料"
          title="明星黑料专区 · 一线动向与传闻梳理"
          desc="汇总与明星相关的网络讨论与传闻，并标注信息来源性质。名字均为化名代称，内容仅供娱乐讨论，请以当事人官方信息为准。"
        />

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {starItems.map((item) => (
            <article
              key={item.id}
              className="flex gap-4 rounded-lg bg-background-100 border border-background-200 p-4 md:p-5 hover:border-primary-300 transition-colors"
            >
              <div className="w-16 h-16 md:w-20 md:h-20 shrink-0 rounded-full overflow-hidden bg-background-300">
                <img
                  src={item.avatar}
                  alt={`${item.name} 相关讨论配图`}
                  title={`${item.name} - 黑料吃瓜网`}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1.5 flex-wrap">
                  <span className="font-heading text-lg text-foreground-950">{item.name}</span>
                  <span className="px-2 py-0.5 rounded-md bg-primary-100 text-primary-700 text-[11px] font-label">
                    {item.tag}
                  </span>
                </div>
                <h3 className="text-sm md:text-base text-foreground-900 leading-snug mb-2 font-body">{item.title}</h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed font-body line-clamp-2">{item.claim}</p>
                <span className="inline-flex items-center gap-1 mt-3 text-[11px] md:text-xs text-primary-600 font-label">
                  <i className="ri-fire-line" aria-hidden="true"></i>
                  讨论热度 {item.heat}
                </span>
              </div>
            </article>
          ))}
        </div>

        <p className="mt-6 flex items-start gap-2 text-xs md:text-sm text-foreground-500 leading-relaxed font-body">
          <i className="ri-error-warning-line text-accent-600 mt-0.5" aria-hidden="true"></i>
          以上条目为网络公开讨论的整理与转述，涉及人物均为化名，不代表本网立场，也不构成对任何事实的认定。
        </p>
      </div>
    </section>
  );
}